import React from 'react'

import { AsideSection } from '../AsideSection'
import { MedicoesCard } from './MedicoesCard'

export interface MedicoesSectionProps {
  prontuarioId: ID
  dataAtendimento: Instant
}

export function MedicoesSection(props: MedicoesSectionProps) {
  return (
    <AsideSection title='Medições' type='clickable'>
      <MedicoesCard {...props} />
    </AsideSection>
  )
}
